import { BaseComponent } from '../base.component';
import { AfterViewChecked, Component, AfterViewInit, ViewChildren, QueryList } from '@angular/core';


@Component({
    selector: 'app-lazy-images',
    template: `NO UI TO BE FOUND HERE!`

})
export class LazyImagesComponent extends BaseComponent implements AfterViewChecked {
    public totalImages: number = 0;
    public loadedImages: boolean = false;
    // @ViewChildren(".mylazy") anchors: QueryList<any>;

    constructor() {
        super();
    }

    public reloadImages() {
        this.loadedImages = false;
        this.loadLazyImages();
    }

    public loadLazyImages() {
        if (typeof window === 'undefined')
            return;

        if ("IntersectionObserver" in window && this.loadedImages === false) {
            let lazyloadImages = document.querySelectorAll(".mylazy");
            // console.log("LazyImagesComponent.loadLazyImages ENTER " + this.totalImages + " === " + lazyloadImages.length);
            if (!lazyloadImages || lazyloadImages.length === 0) {
                return;
            }
            //            if (lazyloadImages.length === this.totalLazyImages) {
            //                return;
            //            }
            if (lazyloadImages.length < this.totalImages) {
                return;
            }
            this.loadedImages = true;
            // console.log("LazyImagesComponent.loadLazyImages " + this.totalImages + " === " + lazyloadImages.length);
            var imageObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var image = entry.target;
                        image.classList.remove("mylazy");
                        imageObserver.unobserve(image);
                    }
                });
            });

            lazyloadImages.forEach(function (image) {
                imageObserver.observe(image);
            });
        }
    }
    /*
        ngAfterViewInit() {
            console.log("ngAfterViewInit " + this.totalImages + " " + document.querySelectorAll(".mylazy").length);
            if (typeof window === 'undefined')
                return;
            this.loadLazyImages();
        }
    */

    ngAfterViewChecked() {
        if (typeof window === 'undefined')
            return;
        //console.log("ngAfterViewChecked " + this.totalImages + " " + document.querySelectorAll(".mylazy").length);

        if (document && document.querySelectorAll(".mylazy").length >= this.totalImages && this.totalImages > 0)
            this.loadLazyImages();
    }

}